module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-ar-SA.d3ab8274.jpg";